/**
 * Kody błędów Firebase Auth sprowadzone do spraw, które użytkownik może zrozumieć i naprawić.
 * Teksty: `auth:screens.errors.<rodzaj>`. Wcześniej ekrany wołały nieistniejące klucze
 * `common:firebaseAuthErrors.*`, więc w UI pojawiał się surowy klucz zamiast komunikatu.
 */
export type AuthErrorKind =
  | 'credentials'
  | 'tooMany'
  | 'disabled'
  | 'network'
  | 'emailInUse'
  | 'weakPassword'
  | 'invalidEmail'
  | 'expiredLink'
  | 'unknown';

const KINDS: Record<string, AuthErrorKind> = {
  // Od SDK 9 z ochroną przed wyliczaniem kont zły e-mail i złe hasło dają ten sam kod — i dobrze.
  'auth/invalid-credential': 'credentials',
  'auth/invalid-login-credentials': 'credentials',
  'auth/wrong-password': 'credentials',
  'auth/user-not-found': 'credentials',
  'auth/too-many-requests': 'tooMany',
  'auth/user-disabled': 'disabled',
  'auth/network-request-failed': 'network',
  'auth/email-already-in-use': 'emailInUse',
  'auth/weak-password': 'weakPassword',
  'auth/invalid-email': 'invalidEmail',
  'auth/expired-action-code': 'expiredLink',
  'auth/invalid-action-code': 'expiredLink',
  'auth/argument-error': 'expiredLink',
};

export function authErrorKind(code: string | null | undefined): AuthErrorKind | null {
  if (!code) return null;

  return KINDS[code] ?? 'unknown';
}
